module.exports = import("https://us-east-1.online.tableau.com/javascripts/api/tableau.embedding.3.latest.js");;